import {
  DeliveryManifestEntities,
  DeliveryManifestData,
  DetailSttDeliveryManifest,
  DeliveryManifestPdfData,
  DeliveryManifestPdfStt,
  DeliveryManifestPdfPieces,
  UpdateDeliveryResponse
} from "@/domain/entities/DeliveryManifest";
import { Pagination } from "@/domain/entities/Pagination";
import { AxiosResponse } from "axios";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";

export class DeliveryManifestMapper {
  public convertDeliveryManifestDataFromApi(
    res: AxiosResponse<any>
  ): DeliveryManifestEntities {
    const { data } = res;
    const deliveryManifest: DeliveryManifestData[] = [];
    if (data.data.length === 0) {
      return new DeliveryManifestEntities(
        new Pagination(data.meta.page, data.meta.limit),
        []
      );
    } else {
      data.data.map((item: any) => {
        deliveryManifest.push(
          new DeliveryManifestData(
            item.delivery_manifest_id,
            item.delivery_manifest_total_stt,
            item.delivery_manifest_total_stt_piece,
            item.delivery_manifest_no,
            item.delivery_manifest_total_gross_weight,
            item.delivery_manifest_total_volume_weight,
            item.delivery_manifest_created_at,
            item.delivery_manifest_created_name
          )
        );
      });
    }
    return new DeliveryManifestEntities(
      new Pagination(data.meta.page, data.meta.limit),
      deliveryManifest
    );
  }

  public convertResponseUpdateDelivery(
    result: AxiosResponse<any>
  ): ResponsePayload {
    const { data } = result;
    return new ResponsePayload({
      success: data.success,
      message: data.message,
      data: new UpdateDeliveryResponse(
        data.data.delivery_manifest_id,
        data.data.total_stt_success,
        data.data.total_stt_failed,
        data.data.stt_failed
      )
    });
  }

  public convertDetailSttInformationFromApi(
    res: AxiosResponse
  ): DetailSttDeliveryManifest[] {
    const {
      data: { data }
    } = res;
    const listOfDetailStt: Array<DetailSttDeliveryManifest> = [];
    if (data[0].stt !== null) {
      for (const index in data) {
        if (data[index].piece !== null) {
          listOfDetailStt.push(this._mapDetailSttDeliveryManifest(data[index]));
        }
      }
      return listOfDetailStt;
    } else {
      return [
        new DetailSttDeliveryManifest(
          false,
          data[0].error_message,
          "",
          "",
          0,
          "",
          "",
          "",
          "",
          "",
          0,
          0,
          0,
          0,
          "",
          "",
          "",
          "",
          false,
          "",
          ""
        )
      ];
    }
  }

  _mapDetailSttDeliveryManifest(data: any) {
    return new DetailSttDeliveryManifest(
      data.is_allow_update_status,
      data.error_message,
      data.stt.stt_no,
      data.stt.bag_no,
      data.stt.stt_total_piece,
      `${data.stt.stt_destination_city_id} - ${data.stt.stt_destination_city_name}`,
      data.stt.stt_product_type,
      data.stt.stt_wood_packing.toLowerCase() === "Yes" ? "Ya" : "Tidak",
      data.stt.stt_commodity_name,
      data.stt.stt_cod_amount,
      data.stt.stt_gross_weight,
      data.stt.stt_volume_weight,
      data.stt.stt_chargeable_weight,
      data.stt.stt_delivery_attempt
        ? Number(data.stt.stt_delivery_attempt) + 1
        : 1,
      data.stt.stt_recipient_name,
      data.stt.stt_recipient_address,
      data.stt.stt_recipient_phone,
      data.stt.stt_assessment_status?.toLowerCase(),
      data.is_paid,
      data.stt.stt_elexys_no,
      "",
      data.stt.stt_need_to_relabel
    )
  }

  public convertDeliveryManifestPdfDataFromApi(
    res: AxiosResponse
  ): DeliveryManifestPdfData {
    const {
      data: { data }
    } = res;
    if (data.stt === null) {
      return new DeliveryManifestPdfData();
    } else {
      return new DeliveryManifestPdfData({
        deliveryManifestId: data.delivery_manifest_id,
        deliveryManifestNo: data.delivery_manifest_no,
        deliveryManifestDestinationCityId:
          data.delivery_manifest_destination_city_id,
        deliveryManifestDestinationCityName:
          data.delivery_manifest_destination_city_name,
        deliveryManifestPartnerId: data.delivery_manifest_partner_id,
        deliveryManifestPartnerCode: data.delivery_manifest_partner_code,
        deliveryManifestPartnerName: data.delivery_manifest_partner_name,
        deliveryManifestTotalStt: data.delivery_manifest_total_stt,
        deliveryManifestTotalSttPiece: data.delivery_manifest_total_stt_piece,
        deliveryManifestTotalGrossWeight:
          data.delivery_manifest_total_gross_weight,
        deliveryManifestTotalVolumeWeight:
          data.delivery_manifest_total_volume_weight,
        deliveryManifestCreatedAt: data.delivery_manifest_created_at,
        deliveryManifestCreatedName: data.delivery_manifest_created_name,
        deliveryManifestCreatedRole: data.delivery_manifest_created_role_name,
        stt: data.stt.map(
          (item: any) =>
            new DeliveryManifestPdfStt({
              sttId: item.stt_id,
              sttNo: item.stt_no,
              sttProductType: item.stt_product_type,
              sttTotalPiece: item.stt_total_piece,
              sttDestinationCityId: item.stt_destination_city_id,
              sttDestinationCityName: item.stt_destination_city_name,
              sttWoodPacking: item.stt_wood_packing,
              sttCommodityCode: item.stt_commodity_code,
              sttCommodityName: item.stt_commodity_name,
              sttGrossWeight: item.stt_gross_weight,
              sttVolumeWeight: item.stt_volume_weight,
              sttChargeableWeight: item.stt_chargeable_weight,
              sttCodAmount: item.stt_cod_amount,
              sttRecipientName: item.stt_recipient_name,
              sttRecipientAddress: item.stt_recipient_address,
              sttRecipientPhone: item.stt_recipient_phone,
              sttRefNo: item.stt_no_ref_external,
              sttIsDfod: item.is_dfod,
              sttIsCod: item.is_cod,
              sttUrsaCode: item.stt_destination_district_ursacode,
              piece: item.piece.map(
                (itemPiece: any) =>
                  new DeliveryManifestPdfPieces({
                    sttPieceId: itemPiece.stt_piece_id,
                    sttPieceGrossWeight: itemPiece.stt_piece_gross_weight,
                    sttPieceVolumeWeight: itemPiece.stt_piece_volume_weight,
                    sttPieceNo: itemPiece.stt_piece_no
                  })
              )
            })
        ),
        deliveryManifestUrsaCode: data.delivery_manifest_ursa_code
      });
    }
  }
}
